import * as React from 'react';

import ReactDropzone from 'react-dropzone';

import { Button, ButtonContainer } from '@emburse/ui-core';

import * as style from './Dropzone.styl';

interface IDropzoneProps {
  customBodyText?: string;
  customButtonText?: string;
  customCallback?: () => void;
  isDragging?: boolean;
  multiple: boolean;
  onDragEnter: () => void;
  onDragLeave: () => void;
  onDrop: (acceptedFiles: any) => void;
  hideActionButton?: boolean;
  customDropzoneContent?: any;
}

function callCustomCallback(e: React.MouseEvent, customCallback: () => void) {
  e.stopPropagation();
  customCallback();
}

function renderDropzoneContent(
  isDragging: boolean,
  hideActionButton?: boolean,
  customBodyText?: string,
  customButtonText?: string,
  customCallback?: () => void
) {
  return isDragging ? (
    <div className="flexbox fd-c">
      <span className="dropzone-content">Drop your file here</span>
    </div>
  ) : (
    <div className="flexbox fd-c">
      <span className="dropzone-content">{customBodyText || 'Drag a CSV file here'}</span>
      {!hideActionButton && renderActionButton(customCallback, customButtonText)}
    </div>
  );
}

function renderActionButton(customCallback?: () => void, customButtonText?: string) {
  const buttonOnClick = customCallback ? (e: React.MouseEvent) => callCustomCallback(e, customCallback) : null;

  return (
    <>
      <span className="dropzone-content">or</span>
      <ButtonContainer className="flex jc-c">
        <Button type="button" variant="outlined" onClick={buttonOnClick}>
          {customButtonText || 'Choose a File'}
        </Button>
      </ButtonContainer>
    </>
  );
}

export const Dropzone: React.SFC<IDropzoneProps> = (props) => {
  const {
    customCallback,
    customBodyText,
    customButtonText,
    isDragging,
    multiple,
    onDragEnter,
    onDragLeave,
    onDrop,
    hideActionButton,
    customDropzoneContent
  } = props;

  return (
    <ReactDropzone
      className={style.global + ' file-dropzone center flexbox fd-c jc-c' + (isDragging ? ' is-dragging' : '')}
      multiple={multiple}
      onDragEnter={() => onDragEnter()}
      onDragLeave={() => onDragLeave()}
      onDrop={(acceptedFiles) => onDrop(acceptedFiles)}
    >
      {customDropzoneContent || (
        <div>
          <span className="center icon icon-upload" />
          {renderDropzoneContent(isDragging, hideActionButton, customBodyText, customButtonText, customCallback)}
        </div>
      )}
    </ReactDropzone>
  );
};
